import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import { Button, Modal } from 'components';

const UnscheduleModal = ({
  title,
  onUnschedule,
  onCancel,
  isPublished,
  entityName,
}) => {
  const [isRemoving, setIsRemoving] = useState(false);

  return (
    <Modal
      hideButton
      show
      color="danger"
      confirmationModal
      size="sm"
      footer={
        <Row>
          <Col xs="auto">
            <Button
              color="dark"
              icon={<FontAwesomeIcon icon={faTimes} />}
              onClick={onCancel}
              outline
              disabled={isRemoving}
            >
              Cancel
            </Button>
          </Col>
          <Col xs="auto">
            <Button
              autoFocus
              color="danger"
              icon={<FontAwesomeIcon icon={faTrashAlt} />}
              onClick={() => {
                setIsRemoving(true);
                onUnschedule();
              }}
              loading={isRemoving}
            >
              Yes, Remove
            </Button>
          </Col>
        </Row>
      }
    >
      <h3>
        {isPublished
          ? `${title} is live.
      This will immediately remove the ${entityName} from the app.`
          : `Are you sure you want to remove the schedule from ${title}?`}
      </h3>
    </Modal>
  );
};

UnscheduleModal.propTypes = {
  title: PropTypes.string,
  onUnschedule: PropTypes.func,
  onCancel: PropTypes.func,
  isPublished: PropTypes.bool,
  entityName: PropTypes.string,
};

UnscheduleModal.defaultProps = {
  title: '',
  onUnschedule: () => {},
  onCancel: () => {},
  isPublished: false,
  entityName: '',
};

export default UnscheduleModal;
